export enum BaseSignContractOptions {
  signExternal = 'signExternal',
  signDigital = 'signDigital',
  concretization = 'concretization',
}
